<div class="bg-white dark:bg-gray-800 shadow-md rounded-lg py-4 px-6">
  <h3 class="text-lg font-medium text-gray-900 dark:text-white">Top 20 Most Requested Reports</h3>
  <div class="mt-4">
    <canvas baseChart
      [data]="barChartData"
      [options]="barChartOptions"
      [type]="'bar'">
    </canvas>
  </div>
</div>
